import { TBlogModuleCenter } from '@/app/(blogposts)/blog/blog.types';
import { BlogArticleModuleCentersDesktop } from './BlogArticleModuleCentersDesktop';
import { BlogArticleModuleCentersMobile } from './BlogArticleModuleCentersMobile';

type Props = {
  module: TBlogModuleCenter;
  mobile: boolean;
};

export const BlogArticleModuleCenters: React.FC<Props> = ({
  module,
  mobile = false,
}) => {
  if (mobile) {
    return <BlogArticleModuleCentersMobile module={module} />;
  }

  return <BlogArticleModuleCentersDesktop module={module} />;
};
